import { BetKind, Player, PlayerStates } from '@ppwr/poker'

import { translate } from '../../../i18n'
import { numberWithCommas } from '../../../utils/numberWithCommas'

const noAmountActions = [BetKind.CHECK] as string[]
const outOfHandStates = [
  PlayerStates.Folded.tag,
  PlayerStates.ForeverOut.tag,
  PlayerStates.SitOut.tag,
  PlayerStates.Waiting.tag,
  PlayerStates.Out.tag
] as string[]

export const getLastActionText = (player: Player) => {
  const {
    state: { tag },
    lastAction
  } = player

  if (outOfHandStates.includes(tag)) return translate(`newGameScreen.player.lastAction.${tag}`)

  if (!lastAction?.action) return ''

  const lastActionText = translate(`newGameScreen.player.lastAction.${lastAction.action}`)

  if (noAmountActions.includes(lastAction.action)) return lastActionText

  if (!lastAction.amount) return ''

  return `${lastActionText} ${lastAction.amount > 0 ? numberWithCommas(lastAction.amount) : ''}`
}

export const getLastActionTextForPlayer = (player: Player) => {
  const {
    state: { tag },
    lastAction
  } = player

  if (outOfHandStates.includes(tag)) return translate(`newGameScreen.player.lastActionForPlayer.${tag}`)

  if (!lastAction?.action) return ''

  const lastActionText = translate(`newGameScreen.player.lastActionForPlayer.${lastAction.action}`)

  if (noAmountActions.includes(lastAction.action)) return lastActionText

  if (!lastAction.amount) return ''

  return `${lastActionText} ${lastAction.amount > 0 ? lastAction.amount : ''}`
}
